// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Kvk","left":"styles_left__3ed2D"};